import { ethers } from 'ethers';
import isEqual from 'lodash/isEqual';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { bin_fromHexString, bin_toHexString } from '@towns-protocol/dlog';
export function credentialsFromSignerContext(primaryWalletAddress, delegateWallet, casablancaContext) {
    return {
        privateKey: delegateWallet.privateKey,
        creatorAddress: ethers.utils.getAddress(bin_toHexString(casablancaContext.creatorAddress)),
        delegateSig: casablancaContext.delegateSig
            ? bin_toHexString(casablancaContext.delegateSig)
            : undefined,
        loggedInWalletAddress: primaryWalletAddress,
    };
}
export function credentialsToSignerContext(credentials) {
    const pk = credentials.privateKey.slice(2);
    const context = {
        signerPrivateKey: () => pk,
        creatorAddress: bin_fromHexString(credentials.creatorAddress),
        delegateSig: credentials.delegateSig
            ? bin_fromHexString(credentials.delegateSig)
            : undefined,
    };
    return context;
}
export const CREDENTIAL_STORE_NAME = 'towns/credentials';
export const useCredentialStore = create(
// John: This is a mere workaround (hack) typing the persist API to avoid
// issue https://github.com/pmndrs/zustand/issues/650
persist((set) => ({
    casablancaCredentialsMap: {},
    setCasablancaCredentials: (homeServerUrl, casablancaCredentials) => set((state) => ({
        ...state,
        casablancaCredentialsMap: {
            ...state.casablancaCredentialsMap,
            [homeServerUrl]: casablancaCredentials,
        },
    })),
    clearCasablancaCredentials: (homeServerUrl, old) => {
        set((state) => {
            if (isEqual(state.casablancaCredentialsMap[homeServerUrl], old)) {
                state.casablancaCredentialsMap[homeServerUrl] = null;
            }
            return state;
        });
    },
}), {
    name: CREDENTIAL_STORE_NAME,
    storage: createJSONStorage(() => localStorage),
    version: 1,
}));
//# sourceMappingURL=use-credential-store.js.map